import { FC } from 'react'
import clsx from 'clsx'
import { MiteneIconBase, MiteneIconProps } from '../../../atoms/icons/MiteneIconBase'

export type Variant = 'premium' | 'pro' | 'premium_user'

const COLOR_CLASSES: Record<Variant, string> = {
  premium: 'text-mi-premium-family',
  pro: 'text-mi-premium-family-pro',
  premium_user: 'text-mi-premium-user',
}

interface Props extends MiteneIconProps {
  variant?: Variant
  size?: MiteneIconProps['size']
}

export const MiteneCrownIcon: FC<Props> = (
  {
    variant = 'premium',
    className,
    ...props
  }) => {
  return (
    <MiteneIconBase
      viewBox='0 0 20 20'
      className={clsx(COLOR_CLASSES[variant], className)}
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM12.7333 8.49998C12.675 8.54165 12.5833 8.52498 12.5417 8.46665L10.2167 4.72498C10.1167 4.56665 9.88333 4.56665 9.78333 4.72498L7.45833 8.46665C7.41666 8.53331 7.33333 8.54998 7.26666 8.49998L3.95 6.11665C3.85833 6.05832 3.73333 6.13331 3.75 6.24165L4.7 12.5833C4.73333 12.8416 4.95833 13.0333 5.21666 13.0333H14.7833C15.0417 13.0333 15.2667 12.8416 15.3 12.5833L16.25 6.24165C16.2667 6.13331 16.1417 6.04998 16.05 6.11665L12.7333 8.49998ZM14.6333 14.0833H5.53332C5.16973 14.0833 4.87498 14.3762 4.87498 14.7375C4.87498 15.0988 5.16973 15.3917 5.53332 15.3917H14.6333C14.9969 15.3917 15.2917 15.0988 15.2917 14.7375C15.2917 14.3762 14.9969 14.0833 14.6333 14.0833Z'
      />
    </MiteneIconBase>
  )
}
